// store/salesCacheStore.ts
import { create } from 'zustand'
import { persist } from 'zustand/middleware'

import type { SalesTransaction } from 'types/api/earning'

interface SalesCachePersistedState {
  sales: SalesTransaction[]
  lastFetched: number | null
}

interface SalesCacheState extends SalesCachePersistedState {
  setSales: (sales: SalesTransaction[]) => void
  getSales: () => SalesTransaction[]
  setLastFetched: (timestamp: number) => void
  clear: () => void
}

export const useSalesCacheStore = create<SalesCacheState>()(
  persist(
    (set, get) => ({
      sales: [],
      lastFetched: null,
      setSales: sales => set({ sales }),
      getSales: () => get().sales,
      setLastFetched: timestamp => set({ lastFetched: timestamp }),
      clear: () => set({ sales: [], lastFetched: null }),
    }),
    {
      name: 'sales-cache',
      partialize: (state): SalesCachePersistedState => ({
        sales: state.sales,
        lastFetched: state.lastFetched,
      }),
    }
  )
)
